export default __webpack_public_path__ + "static/media/AURA_PRO.114a50c5.jpg";